import { OrderHubStatus } from "../hooks/useOrderHub";

const VIEW: Record<OrderHubStatus, { label: string; color: string; title: string; pulse?: boolean } | null> = {
  idle: null,
  connecting: { label: "Bağlanıyor", color: "#d97706", title: "Canlı sipariş bildirimine bağlanılıyor…" },
  connected: { label: "Canlı", color: "#10b981", title: "Yeni siparişler anında düşer.", pulse: true },
  reconnecting: { label: "Yeniden bağlanıyor", color: "#d97706", title: "Bağlantı koptu, yeniden kuruluyor. Liste bağlanınca tazelenecek." },
  disconnected: { label: "Bağlantı yok", color: "#dc2626", title: "Canlı bildirim kopuk; otomatik olarak tekrar deneniyor. Yeni siparişler için sayfayı yenileyebilirsiniz." },
  denied: { label: "Bildirim yetkisi yok", color: "#dc2626", title: "Bu restoranın sipariş bildirimlerine katılma yetkiniz yok (restoran bağlantınız pasif olabilir)." },
};

/** Sipariş hub'ının bağlantı durumu — "yeni sipariş neden gelmedi" sorusunun ilk cevabı. */
export default function OrderHubStatusBadge({ status }: { status: OrderHubStatus }) {
  const v = VIEW[status];
  if (!v) return null;
  return (
    <span title={v.title} style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: "0.68rem", fontWeight: 700, color: v.color, marginTop: 2 }}>
      <span style={{ position: "relative", width: 8, height: 8, display: "inline-flex" }}>
        {v.pulse && (
          <span style={{ position: "absolute", inset: 0, borderRadius: "50%", background: v.color, opacity: 0.45, animation: "ohs-ping 1.6s ease-out infinite" }} />
        )}
        <span style={{ position: "relative", width: 8, height: 8, borderRadius: "50%", background: v.color }} />
      </span>
      {v.label}
      <style>{"@keyframes ohs-ping { 0% { transform: scale(1); opacity: .5 } 100% { transform: scale(2.4); opacity: 0 } }"}</style>
    </span>
  );
}
